/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import $ from 'jquery';

import { PAGE_THREATS } from '../../../config/pages';

class ThreatsThree extends Component {
    static buttonClick(e) {
        const $text = $(e.target).closest('.threats-3-box').find('.section-text-16');
        const $target = $(e.target);
        const $button = $target.hasClass('button') ? $target : $target.closest('.button');
        if ($button.hasClass('expanded')) {
            $button.removeClass('expanded');
            $text.removeClass('expanded').removeAttr('style');
        } else {
            $button.addClass('expanded');
            const height = $text.find('p').outerHeight(true);
            $text.addClass('expanded').height(height);
        }
    }

    static boxesClose() {
        $('.threats-3-box .section-text-16').removeClass('expanded').removeAttr('style');
        $('.threats-3-box .button').removeClass('expanded');
    }

    static pieAnimate() {
        $('.threats-3-chart .pie').addClass('show');
        let x = 0;
        const interval = setInterval(() => {
            x += 1;
            if (x >= 75) {
                clearInterval(interval);
            }
            $('.threats-3-chart .counter').text(`${ x }%`);
        }, 1400 / 75);
    }

    constructor(props) {
        super(props);
        this.state = {
            showPie: false,
            showBoxes: false
        };
        this.scroll = this.scroll.bind(this);
        this.resize = this.resize.bind(this);
        this.windowWidth = $(window).width();
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);
        window.addEventListener('scroll', this.scroll);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
        window.removeEventListener('scroll', this.scroll);
    }

    scroll() {
        if (this.props.page === PAGE_THREATS && $('.container-threats-3').length > 0) {
            const winTop = $(window).scrollTop();
            const winHeight = $(window).height();

            if (this.state.showPie === false) {
                const elemTop = $('.threats-3-chart').offset().top;
                if (elemTop < (winTop + (winHeight / 2))) {
                    this.setState({ showPie: true });
                    ThreatsThree.pieAnimate();
                }
            }

            if (this.state.showBoxes === false) {
                const elemTop = $('.threats-3-boxes').offset().top;
                if (elemTop < (winTop + (winHeight / 2))) {
                    this.setState({ showBoxes: true });
                }
            }
        }
    }

    resize() {
        if ($(window).width() !== this.windowWidth) {
            this.windowWidth = $(window).width();
            ThreatsThree.boxesClose();
            this.scroll();
        }
    }

    render() {
        const { showBoxes } = this.state;
        const { t } = this.props;

        return (
            <div className="container-threats-3" id="container-threats-3">
                <div className="page-threats-3" id="page-threats-3">
                    <div className="layout">
                        <div className="section-title" id="section-title-3">
                            <h2 dangerouslySetInnerHTML={ { __html: t('threats.three.section.title') } }/>
                        </div>
                        <div className="threats-3-chart" id="threats-3-chart">
                            <div className="pie" id="pie-3">
                                <svg viewBox="0 0 32 32">
                                    <circle className="circle" r="16" cx="16" cy="16"/>
                                    <circle className="circle-inside" r="9" cx="16" cy="16"/>
                                </svg>
                                <span className="counter" id="counter-3">0%</span>
                            </div>
                            <div className="section-text" id="section-text-3">
                                <p>{ t('threats.three.text') }</p>
                            </div>
                        </div>
                        <div className="section-boxes threats-3-boxes" id="threats-3-boxes">
                            {
                                t('threats.three.boxes').map((box, index) => (
                                    <div
                                      className={ cx('section-box', 'section-box-mobile-white', 'threats-3-box', { show: showBoxes }) }
                                      key={ index }
                                      id={ `threats-3-box-${ index }` }
                                    >
                                        <div className="inside">
                                            <h2>{ box.title }</h2>
                                            <div className="image">
                                                <img src={ require(`../../../assets/images/threats/3/icon-${ (index + 1) }.svg`) } alt="Lemlock threats"/>
                                            </div>
                                            <div className="section-text-16">
                                                <p id={ `section-text-16-1-${ index }` }>{ box.text }</p>
                                            </div>
                                            <div className="button-box">
                                                <span className="button button-blue" onClick={ ThreatsThree.buttonClick }>
                                                    <span className="more" id={ `button-more-1-${ index }` }>{ t('threats.three.buttons.more') }</span>
                                                    <span className="less" id={ `button-less-1-${ index }` }>{ t('threats.three.buttons.less') }</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className="threats-3-button-container">
                        <p className="threats-3-text">{ t('form.title.breach') }</p>
                        <div className="threats-security-button">
                            <a
                              href={ t('form.link.breach') }
                              className="threats-3-button"
                              id="threats-3-button"
                            >
                                { t('form.button.breach') }
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ThreatsThree.propTypes = {
    t: PropTypes.func.isRequired,
    page: PropTypes.string.isRequired
};

export default ThreatsThree;



// WEBPACK FOOTER //
// ./src/components/content/threats/ThreatsThree.jsx